import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-allhospital',
  templateUrl: './allhospital.component.html',
  styleUrls: ['./allhospital.component.css']
})
export class AllhospitalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
